import { UserSimple } from './user-simple';

export class BusinessUnitUser extends UserSimple {
  Id: number;
  BusinessUnitId: number;
  UserId: number;
}
